import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TwoFactorInputComponent } from './two-factor-input.component';

@NgModule({
  declarations: [
    TwoFactorInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    TwoFactorInputComponent
  ]
})
export class TwoFactorInputModule { } 